import { API_ENDPOINT } from "../../endpoint";

export const retrieveCountriesService = async (token: string) => {
    try {
        const response = await fetch(`${API_ENDPOINT}/utility/all/country`, {
            method: 'GET',
            headers: {
                'Authorization': `APIKey ${token}`,
                'Content-Type': 'application/json'
            },
        });
        const res = await response.json();
        if (!response.ok) {
            console.error('Error:', res);
            throw new Error(res.message);
        }
        return res.data;
    } catch (error) {
        console.error('API fetch error:', error);
        throw error;
    }
};
